// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setComplianceReportHistoryFilters = createAction('[Compliance Report History Page] Apply Filters', props());
